import {AppBar, Box, Toolbar} from '@mui/material'
import type {FC, ReactElement} from 'react'
import {Link} from 'react-router-dom'
import AppbarLanguage from './AppbarLanguage'
import HelpItem from './HelpItem'
import ToggleTheme from './ToggleTheme'
import {useLogo} from '@shared/hooks/useLogo'

const MinimizedAppbar: FC = (): ReactElement => {
  const {fullLogo} = useLogo()

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: 'background.default',
        borderBottom: 1,
        borderColor: 'divider',
        boxShadow: 'none',
      }}
      data-testid="mbai-main-minimized-appbar"
    >
      <Toolbar sx={{minWidth: 0}}>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
          }}
        >
          <Link className="" to="/">
            <img src={fullLogo} style={{maxWidth: '150px'}} alt="MontBlancAI logo" />
          </Link>
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                mr: 1,
                my: 'auto',
              }}
            >
              <HelpItem />
            </Box>
            <Box
              sx={{
                mr: 1,
                my: 'auto',
              }}
            >
              <ToggleTheme />
            </Box>
            <AppbarLanguage />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default MinimizedAppbar
